import type { ReactLocalization } from "@fluent/react";

export const PAYMENT_REJECTION_CODES = {
  AGNT: "Agent decision",
  AMDT: "Already returned",
  ADAC: "Awaiting debt authorization",
  ARPL: "Awaiting reply",
  AC06: "Blocked account",
  AC04: "Closed account",
  AC07: "Closed creditor account",
  CUST: "Customer decision",
  DUPL: "Duplicate",
  BE01: "Inconsistent end user",
  AM04: "Insufficient funds",
  AC03: "Invalid creditor account",
  BE17: "Invalid creditor identification",
  LEGL: "Legal decision",
  BE04: "Missing incorrect creditor address",
  NARR: "Narrative",
  NOAS: "No answer from customer",
  NOOR: "No original transaction received",
  PTNA: "Passed to next agent",
  RR04: "Regulatory reason",
  RQDA: "Requesting debit authorization",
  AM09: "Wrong amount",
  RC01: "Bank identifier code specified in the message has an incorrect format",
  RC02: "Bank identifier is invalid or missing",
  RC03: "Debtor bank identifier is invalid or missing",
  RC04: "Creditor bank identifier is invalid or missing",
} as const;

export type PAYMENT_REJECTION_CODES_TYPE = keyof typeof PAYMENT_REJECTION_CODES;

export const getPaymentFailureReason = (
  code: string,
  l10n: ReactLocalization,
): string => {
  if (!(code in PAYMENT_REJECTION_CODES)) {
    return code;
  }

  const rejectionCode = code as PAYMENT_REJECTION_CODES_TYPE;
  switch (rejectionCode) {
    case "AGNT":
      return l10n.getString("fednow-reject-reason-agnt");
    case "AMDT":
      return l10n.getString("fednow-reject-reason-amdt");
    case "ADAC":
      return l10n.getString("fednow-reject-reason-adac");
    case "ARPL":
      return l10n.getString("fednow-reject-reason-arpl");
    case "AC06":
      return l10n.getString("fednow-reject-reason-ac06");
    case "AC04":
      return l10n.getString("fednow-reject-reason-ac04");
    case "AC07":
      return l10n.getString("fednow-reject-reason-ac07");
    case "CUST":
      return l10n.getString("fednow-reject-reason-cust");
    case "DUPL":
      return l10n.getString("fednow-reject-reason-dupl");
    case "BE01":
      return l10n.getString("fednow-reject-reason-be01");
    case "AM04":
      return l10n.getString("fednow-reject-reason-am04");
    case "AC03":
      return l10n.getString("fednow-reject-reason-ac03");
    case "BE17":
      return l10n.getString("fednow-reject-reason-be17");
    case "LEGL":
      return l10n.getString("fednow-reject-reason-legl");
    case "BE04":
      return l10n.getString("fednow-reject-reason-be04");
    case "NARR":
      return l10n.getString("fednow-reject-reason-narr");
    case "NOAS":
      return l10n.getString("fednow-reject-reason-noas");
    case "NOOR":
      return l10n.getString("fednow-reject-reason-noor");
    case "PTNA":
      return l10n.getString("fednow-reject-reason-ptna");
    case "RR04":
      return l10n.getString("fednow-reject-reason-rr04");
    case "RQDA":
      return l10n.getString("fednow-reject-reason-rqda");
    case "AM09":
      return l10n.getString("fednow-reject-reason-am09");
    case "RC01":
      return l10n.getString("fednow-reject-reason-rc01");
    case "RC02":
      return l10n.getString("fednow-reject-reason-rc02");
    case "RC03":
      return l10n.getString("fednow-reject-reason-rc03");
    case "RC04":
      return l10n.getString("fednow-reject-reason-rc04");
    default: {
      const unhandledCode: never = rejectionCode;
      return unhandledCode;
    }
  }
};
